(() => {
	const PaymentSchedulesController = (
		$scope,
		$rootScope,
		$http,
		$q,
		$location,
		messageService,
		validationService,
		userService,
		paymentSchedulesDataService,
		accountService,
		settingsService
	) => {
		$scope.$on('$viewContentLoaded', () => {
			$scope.isSaveReminderSpinnningWheelActive = false;
			$scope.isSavePaymentSpinnningWheelActive = false;
			$scope.button_disable = false;
			$scope.editedPaymentSchedule = {};
			$scope.deletablePaymentSchedule = {};
			$scope.payments = [];
			$scope.delIndex = -1;
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: null
			};
			$scope.reminder = {};
			$scope.customizedLabels = {};
			getUser();
			getInvoiceReminder();
			getPaymentReceipt();

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);

			$('#addNewPaymentScheduleModal').on('show.bs.modal', () => {
				$('#addNewPaymentScheduleModal')
					.find('input.ws-number')
					.prop('autocomplete', 'off')
					.prop('min', '1');
			});
		});

		function getUser() {
			$scope.userObservable = accountService.getUserWeb().subscribe(user => {
				if (user !== null && typeof user !== 'undefined') {
					$scope.currencyCode = user.currency.currencyCode;
					settingsService.customizeLabelsObservable.subscribe(data => {
						$scope.customizedLabels = data;
						paymentSchedulesDataService
							.getPaymentScheduleOptions()
							.subscribe(
								data => getPaymentScheduleOptionsSuccessCallback(data),
								err => getPaymentScheduleOptionsErrorCallback(err)
							);
					});
				}
			});
		}
		function getPaymentScheduleOptionsSuccessCallback(data) {
			if (!data) {
				console.error('No data for payment schedule options');
				return;
			}

			$scope.payments.push({
				amount: '',
				type: ''
			});

			const {
				paymentScheduleTypes,
				dateItemsTypes,
				jobDateDependingTypes,
				indexOfOnJobDate,
				indexOfOnInvoiceDate
			} = data;
			$scope.paymentScheduleTypes = configPaymentScheduleTypes(
				paymentScheduleTypes
			);
			$scope.payments[0].type = paymentScheduleTypes[0];
			$scope.dateItemsTypes = dateItemsTypes;
			$scope.payments[0].dateItemsType = dateItemsTypes[0];
			$scope.jobDateDependingTypes = configPaymentScheduleJobDependingTypes(
				jobDateDependingTypes
			);
			$scope.indexOfOnJobDate = indexOfOnJobDate;
			$scope.indexOfOnInvoiceDate = indexOfOnInvoiceDate;
			$scope.paymentsModel = angular.copy($scope.payments);
		}

		function configPaymentScheduleJobDependingTypes(jobDependingTypes) {
			return jobDependingTypes.map(el => setCorrectNaming(el));
		}

		function setCorrectNaming(el) {
			const res = { id: el, name: '' };
			if (el.includes('main shoot')) {
				res.name = el.replace(
					'main shoot',
					$scope.customizedLabels.mainShootLabel.toLowerCase()
				);
			} else if (el.includes('invoice date')) {
				res.name = el.replace('invoice date', 'quote or invoice created date');
			} else {
				res.name = el;
			}
			return res;
		}

		function configPaymentScheduleTypes(types) {
			const typesObjArray = [];
			types.forEach(type => {
				typesObjArray.push({
					name: type === 'Dollars' ? $scope.currencyCode : type,
					key: type
				});
			});

			return typesObjArray;
		}

		function getPaymentScheduleOptionsErrorCallback() {
			toastr.error('No available payment types', 'Error');
		}

		function getInvoiceReminder() {
			$http
				.get('/protected/rest/invoice_reminder/get')
				.then(result => {
					if (result.data) {
						$scope.reminder = result.data;
					} else {
						$q.reject(result);
					}
				})
				.catch(messageService.showDefaultErrorMessage);
		}

		function getPaymentReceipt() {
			$http
				.get('/protected/rest/payment-receipt/settings/get')
				.then(result => {
					if (result.data) {
						$scope.paymentReceipt = result.data;
					} else {
						$q.reject(result);
					}
				})
				.catch(messageService.showDefaultErrorMessage);
		}

		$scope.saveReminder = function() {
			if (
				$scope.reminder.beforeDueDate &&
				$scope.reminder.daysBeforeDueDate == null
			) {
				messageService.showToaster('e_3', 'generalValidation');
			} else if (
				$scope.reminder.afterDueDate &&
				$scope.reminder.daysAfterDueDate == null
			) {
				messageService.showToaster('e_3', 'generalValidation');
			} else if (
				$scope.reminder.afterDueDate &&
				$scope.reminder.daysRegularlyAfterDueDate == null
			) {
				messageService.showToaster('e_3', 'generalValidation');
			} else {
				$scope.isSaveReminderSpinnningWheelActive = true;
				$scope.reminder.emailText = $rootScope.addMaiStyling(
					$scope.reminder.emailText
				);

				$http({
					url: '/protected/rest/invoice_reminder/save',
					method: 'POST',
					data: $scope.reminder
				}).then(
					result => {
						if (result.data.message || result.status === 204) {
							messageService.showToaster('s_1', 'paymentSchedules');
						} else if (result.data.errorMessage) {
							messageService.showToaster('e_2', 'paymentSchedules');
						} else {
							messageService.showToaster('e_0', 'general');
						}
						$scope.isSaveReminderSpinnningWheelActive = false;
					},
					result => {
						if (result.status === 422) {
							const path = $location.path();
							if (path.indexOf('payment_schedules') !== -1) {
								$scope.isSaveReminderSpinnningWheelActive = false;
								return messageService.showToaster('e_0', 'paymentSchedules');
							}
							$scope.isSaveReminderSpinnningWheelActive = false;
							return messageService.showToaster('e_0', 'general');
						}
						$scope.isSaveReminderSpinnningWheelActive = false;
						return messageService.showToaster('e_0', 'general');
					}
				);
			}
		};

		$scope.savePaymentReceipt = function() {
			$scope.paymentReceipt.emailText = $rootScope.addMaiStyling(
				$scope.paymentReceipt.emailText
			);
			$scope.isSavePaymentSpinnningWheelActive = true;

			$http({
				url: '/protected/rest/payment-receipt/settings/save',
				method: 'POST',
				data: $scope.paymentReceipt
			})
				.then(successSaveReceipt)
				.catch(errorSaveReceipt)
				.finally(() => {
					$scope.isSavePaymentSpinnningWheelActive = false;
				});

			function successSaveReceipt() {
				messageService.showToaster('s_4', 'paymentSchedules');
			}
		};

		function errorSaveReceipt({ status, data }) {
			const errorMessage = data.errorMessage;
			let errorCode, errorPlace, value;

			if (status >= 400 && status < 500 && errorMessage) {
				if (
					errorMessage.includes(
						"You're trying to save the Receipt of payment email template without a invoice link!"
					)
				) {
					errorCode = 'e_4';
					errorPlace = 'emailTemplate';
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		$scope.addPayment = function() {
			$scope.payments.push({
				jobDateDepending: $scope.jobDateDependingTypes[0].id,
				dateItemsType: $scope.dateItemsTypes[0],
				type: $scope.paymentScheduleTypes[0].key
			});
		};

		$scope.clearForm = function() {
			$scope.name = '';
			$scope.payments = [
				{
					amount: null,
					dateItemsType: $scope.dateItemsTypes[0],
					jobDateDepending: $scope.jobDateDependingTypes[0].id,
					type: $scope.paymentScheduleTypes[0].key
				}
			];
		};

		$scope.breadcrumbs = [
			{ link: '/', title: 'Dashboard' },
			{ link: '/settings', title: 'Settings' },
			{ link: null, title: 'Invoice & Payment Settings' }
		];

		function paymentScheduleCreationSuccessCallback(data) {
			if (data) {
				if (data.success) {
					delete $rootScope.error;
					$('#addNewPaymentScheduleModal').modal('hide');
					messageService.showToaster('s_0', 'paymentSchedules', $scope.name);

					$scope.name = '';
					$scope.payments = $scope.paymentsModel;
					$scope.payments[0].jobDateDepending =
						$scope.jobDateDependingTypes[0].id;

					$scope.button_disable = false;
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				} else if (data.errorMessage) {
					toastr.error(data.errorMessage, 'Error');
					$scope.button_disable = false;
				}
			}
			$scope.button_disable = false;
		}

		function paymentScheduleCreationErrorCallback(data) {
			$rootScope.authenticated = false;
			$rootScope.error = true;
			$rootScope.error_message = 'Failed request to server';
			if (data.errorMessage) {
				if (data.errorMessage === 'Percents shoud be in 0 - 100 range') {
					messageService.showToaster('e_1', 'paymentSchedules');
				} else {
					messageService.showToaster('e_3', 'paymentSchedules');
				}
			} else {
				messageService.showToaster('e_0', 'general');
			}
			$scope.button_disable = false;
		}

		$scope.createPaymentSchedule = function() {
			$scope.button_disable = true;

			if (validationService.isStringEmpty($scope.name)) {
				$scope.button_disable = false;
				return messageService.showToaster('e_3', 'general', 'Name');
			}

			const result = {
				name: $scope.name,
				paymentSchedulePartDTOs: $scope.payments
			};

			paymentSchedulesDataService
				.createPaymentSchedule(result)
				.finally(() => {
					$scope.button_disable = false;
				})
				.subscribe(
					data => paymentScheduleCreationSuccessCallback(data),
					err => paymentScheduleCreationErrorCallback(err)
				);
		};

		$scope.duplicatePaymentSchedule = function(index) {
			getPaymentSchedule($scope.paymentSchedules[index].id, data => {
				$scope.name = data.name;
				$scope.payments = data.paymentSchedulePartDTOs;
				$('#addNewPaymentScheduleModal').modal('show');
			});
		};

		$scope.editPaymentSchedule = function(index) {
			$.blockUI();
			$http
				.get(
					`/protected/rest/payment_schedule?paymentScheduleId=${
						$scope.paymentSchedules[index].id
					}`
				)
				.then(result => {
					$.unblockUI();
					if (result.data) {
						angular.copy(result.data, $scope.editedPaymentSchedule);
						$('#editPaymentScheduleModal').modal('show');
					} else {
						// toastr["error"]("Failed request to server", 'Error');
						messageService.showToaster('e_0', 'general');
					}
				});
		};

		$scope.addPaymentToEdited = function() {
			if (!$scope.editedPaymentSchedule.paymentSchedulePartDTOs) {
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs = [];
			}
			$scope.editedPaymentSchedule.paymentSchedulePartDTOs.push({
				jobDateDepending: $scope.jobDateDependingTypes[0].id,
				dateItemsType: $scope.dateItemsTypes[0],
				type: $scope.paymentScheduleTypes[0].key
			});
		};

		function paymentScheduleUpdatingSuccessCallback(data) {
			if (data) {
				if (data.success) {
					$('#editPaymentScheduleModal').modal('hide');
					delete $rootScope.error;

					messageService.showToaster(
						's_3',
						'paymentSchedules',
						$scope.editedPaymentSchedule.name
					);
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				} else {
					toastr.error(data.message, 'Error');
					$rootScope.error = true;
					$rootScope.error_message = data.message;
				}
			}
			$scope.button_disable = false;
		}

		function paymentScheduleUpdatingErrorCallback(data) {
			$rootScope.authenticated = false;
			$rootScope.error = true;
			$rootScope.error_message = 'Failed request to server';
			if (data.errorMessage) {
				if (data.errorMessage === 'Percents shoud be in 0 - 100 range') {
					messageService.showToaster('e_1', 'paymentSchedules');
				} else {
					messageService.showToaster('e_2', 'general', data.errorMessage);
				}
			} else {
				messageService.showToaster('e_0', 'general');
			}
			$scope.button_disable = false;
		}

		$scope.updatePaymentSchedule = function() {
			$scope.button_disable = true;

			if (validationService.isStringEmpty($scope.editedPaymentSchedule.name)) {
				$scope.button_disable = false;
				messageService.showToaster('e_3', 'general');
				return;
			}

			paymentSchedulesDataService
				.updatePaymentSchedule($scope.editedPaymentSchedule)
				.subscribe(
					data => paymentScheduleUpdatingSuccessCallback(data),
					err => paymentScheduleUpdatingErrorCallback(err)
				);
		};

		$scope.showDeleteWindow = function(index) {
			angular.copy(
				$scope.paymentSchedules[index],
				$scope.deletablePaymentSchedule
			);
			$scope.delIndex = index;
		};

		$scope.deleteEditedPaymentPart = function(index) {
			if ($scope.editedPaymentSchedule.paymentSchedulePartDTOs[index].id) {
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs[
					index
				].isDeleted = true;
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs[index].amount = 0;
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs[
					index
				].dateItemsAmount = 0;
			} else {
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs.splice(index, 1);
			}
		};
		$scope.deleteNewPaymentPart = function(index) {
			$scope.payments.splice(index, 1);
		};

		function paymentScheduleDeletingSuccessCallback(data) {
			if (data) {
				if (data.success) {
					delete $rootScope.error;
					// toastr["success"](data.message, 'Success');
					// $scope.deletablePaymentSchedule
					messageService.showToaster(
						's_2',
						'paymentSchedules',
						$scope.deletablePaymentSchedule.name
					);
					$scope.paymentSchedules.splice($scope.delIndex, 1);
					$scope.button_disable = false;
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				} else {
					toastr.error(data.message, 'Error');
					$rootScope.error = true;
					$rootScope.error_message = data.message;
					$scope.button_disable = false;
				}
			}
			$scope.button_disable = false;
		}

		function paymentScheduleDeletingErrorCallback() {
			$rootScope.authenticated = false;
			$rootScope.error = true;
			$rootScope.error_message = 'Failed request to server';
			// toastr["error"]("Failed request to server", 'Error');
			messageService.showToaster('e_0', 'general');
			$scope.button_disable = false;
		}

		$scope.deletePaymentSchedule = function() {
			$scope.button_disable = true;
			$('#deletePaymentScheduleModal').modal('hide');

			paymentSchedulesDataService
				.deletePaymentSchedule($scope.deletablePaymentSchedule)
				.subscribe(
					data => paymentScheduleDeletingSuccessCallback(data),
					err => paymentScheduleDeletingErrorCallback(err)
				);
		};

		function getPaymentSchedule(id, outObject) {
			$http
				.get(`/protected/rest/payment_schedule?paymentScheduleId=${id}`)
				.then(result => {
					$.unblockUI();
					if (result.data) {
						outObject(result.data);
					} else {
						// toastr["error"]("Failed request to server", 'Error');
						messageService.showToaster('e_0', 'general');
					}
				});
		}

		function getResultsPage(pageNumber, perPage, predicate, reverse) {
			let changed = false;
			if (
				typeof predicate !== 'undefined' &&
				predicate != null &&
				typeof reverse !== 'undefined' &&
				reverse != null
			) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (typeof perPage !== 'undefined' && perPage != null) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (typeof pageNumber !== 'undefined' && pageNumber != null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if (
				$scope.pageRequest &&
				$scope.totalItems != 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				$http
					.get(
						`/protected/rest/company_payment_schedules?perPage=${
							$scope.pageRequest.perPage
						}&page=${$scope.pageRequest.page}&predicate=${
							$scope.pageRequest.pageOrder.predicate
						}&reverse=${$scope.pageRequest.pageOrder.reverse}`
					)
					.then(result => {
						if (result.data && result.data.pageRequest) {
							$scope.pageRequest = result.data.pageRequest;
						}
						$scope.pageNumbers = [];
						$scope.totalItems = result.data.total;
						let pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
						pagesCount = Math.ceil(pagesCount);
						for (let i = 1; i <= pagesCount; i++) {
							$scope.pageNumbers[i - 1] = i;
						}
						$scope.paymentSchedules = result.data.results;
					});
			}
		}

		$scope.order = function(predicate) {
			$scope.pageRequest.pageOrder.reverse =
				$scope.pageRequest.pageOrder.predicate === predicate
					? !$scope.pageRequest.pageOrder.reverse
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};
		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};
		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = disabled => {
			if (!disabled) {
				if (
					$scope.totalItems >=
					$scope.pageRequest.page * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.disableDragDrop = () => true;
	};

	angular
		.module('main')
		.controller('PaymentSchedulesController', PaymentSchedulesController);

	PaymentSchedulesController.$inject = [
		'$scope',
		'$rootScope',
		'$http',
		'$q',
		'$location',
		'messageService',
		'validationService',
		'userService',
		'paymentSchedulesDataService',
		'accountService',
		'settingsService'
	];
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/paymentSchedulesControllers.js